import { axiosInstance } from './axios';
import { IResponseDeskCounter } from 'dto/responses/IResponseDeskCounter';
import { IError } from 'dto/IError';
import useCustomMutation from 'hooks/useCustomMutation';
import useCustomQuery from 'hooks/useCustomQuery';

const queryKeys = {
  getCount: "deskService.getCount",
  getTodos: () => ["deskService.getTodos"],
  getEvents: "deskService.getEvents",
  getContacts: "deskService.getContacts",
};

const getCount = (): Promise<{ data: IResponseDeskCounter }> => {
  return axiosInstance.get(`/desk/counters`);
};

const useGetCount = () => {
  return useCustomQuery(queryKeys.getCount, getCount);
};


interface IItem {
  Id: string;
  Kind: number;
}

export interface ISetDesk {
  Items: IItem[]
  Show: boolean;
}

const setDesk = (payload: ISetDesk): Promise<{ data: IError }> => {
  return axiosInstance.post('/Desk', payload)
}

const useSetDesk = () => {
  return useCustomMutation(setDesk)
}


// ── Lista ToDo z Biurka (slajd „Terminarz i zadania") ──────────────
// Lista płaska — drzewo (podzadania) odtwarzane z ParentLocalId, kolejność z Position.
// Data zadania absolutna (yyyy-MM-dd); kubełek Wczoraj/Dziś/Jutro wylicza front-end.
export interface ITodoDto {
  LocalId: string;
  ParentLocalId?: string | null;
  Text: string;
  Done: boolean;
  Pin: boolean;
  Date?: string | null;
  Position: number;
}

export interface IGetTodosResponse {
  Todos: ITodoDto[];
}

// Listy Biurka są lustrem stanu lokalnego: po pierwszej hydracji to klient jest
// źródłem prawdy, a zmiany wędrują do BE przez …/sync. Dlatego wyłączamy
// automatyczny refetch w tle — i tak był ignorowany (guard hydracji), a generował
// zbędne re-rendery (potencjalne źródło chwilowych zacięć przy dużych zmianach).
const MIRROR_QUERY_OPTS = {
  refetchOnWindowFocus: false,
  refetchOnReconnect: false,
  staleTime: Infinity,
  retry: false,
} as const;

const getTodos = (): Promise<{ data: IGetTodosResponse }> => {
  return axiosInstance.get(`/desk/todos`);
};

const useGetTodos = () => {
  return useCustomQuery(
    queryKeys.getTodos(),
    () => getTodos(),
    MIRROR_QUERY_OPTS,
  );
};

const syncTodos = (payload: {
  Todos: ITodoDto[];
}): Promise<{ data: IError }> => {
  return axiosInstance.post("/desk/todos/sync", payload);
};

const useSyncTodos = () => {
  return useCustomMutation(syncTodos);
};

// ── Terminarz Biurka (wydarzenia) ──────────────────────────────────
export interface IEventDto {
  LocalId: string;
  Date?: string | null;
  Time?: string | null;
  Dur: number;
  Title: string;
  Sub?: string | null;
  Accent?: string | null;
  Type?: string | null;
  Deleted?: boolean;
  CaseId?: string | null;
  CaseTitle?: string | null;
  Position: number;
}

const getEvents = (): Promise<{ data: { Events: IEventDto[] } }> => {
  return axiosInstance.get('/desk/events');
};

const useGetEvents = () => {
  return useCustomQuery(queryKeys.getEvents, getEvents, MIRROR_QUERY_OPTS);
};

const syncEvents = (payload: { Events: IEventDto[] }): Promise<{ data: IError }> => {
  return axiosInstance.post('/desk/events/sync', payload);
};

const useSyncEvents = () => {
  return useCustomMutation(syncEvents);
};

// ── „Skontaktuj się" (zaplanowane kontakty) ────────────────────────
export interface IContactDto {
  LocalId: string;
  Name: string;
  Purpose?: string | null;
  Phone?: string | null;
  Email?: string | null;
  Date?: string | null;
  Time?: string | null;
  Done: boolean;
  NoteId?: string | null;
  NoteTitle?: string | null;
  NoteContent?: string | null;
  Position: number;
}

const getContacts = (): Promise<{ data: { Contacts: IContactDto[] } }> => {
  return axiosInstance.get('/desk/contacts');
};

const useGetContacts = () => {
  return useCustomQuery(queryKeys.getContacts, getContacts, MIRROR_QUERY_OPTS);
};

const syncContacts = (payload: { Contacts: IContactDto[] }): Promise<{ data: IError }> => {
  return axiosInstance.post('/desk/contacts/sync', payload);
};

const useSyncContacts = () => {
  return useCustomMutation(syncContacts);
};


export default {
  useGetCount,
  useSetDesk,
  useGetTodos,
  useSyncTodos,
  useGetEvents,
  useSyncEvents,
  useGetContacts,
  useSyncContacts
};
